export const AccountTypes = {
    Consumer: "Consumer",
    BusinessProspect: "BusinessProspect",
    BusinessCustomer: "BusinessCustomer",
};
